import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ImportSalesModal from "../../components/ImportSalesModal/ImportSalesModal";
import "./SalesAnalytics.css";

const TABS = [
    { key: "overview",  label: "Overview" },
    { key: "products",  label: "Products" },
    { key: "customers", label: "Customers" },
    { key: "inventory", label: "Inventory" },
];

const SalesAnalytics = ({ userId, setHeaderTitle }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "overview");
    const [importModalOpen, setImportModalOpen] = useState(false);

    useEffect(() => {
        setHeaderTitle("Sales Analytics");
    }, []);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };
    
    const renderTab = () => {
        switch (activeTab) {
            case "overview":  return <TabRoadmap sections={OVERVIEW_SECTIONS} />;
            case "products":  return <TabRoadmap sections={PRODUCTS_SECTIONS} />;
            case "customers": return <TabRoadmap sections={CUSTOMERS_SECTIONS} />;
            case "inventory": return <TabRoadmap sections={INVENTORY_SECTIONS} />;
            default:          return <TabRoadmap sections={OVERVIEW_SECTIONS} />;
        }
    };

    return (
        <div className="sales-analytics">
            <div className="sa-page-header">
                <div className="sa-page-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="20" x2="18" y2="10" />
                        <line x1="12" y1="20" x2="12" y2="4" />
                        <line x1="6"  y1="20" x2="6"  y2="14" />
                    </svg>
                    <h1>Sales Analytics</h1>
                </div>
            </div>

            <div className="sa-tab-row">
                <div className="sa-tab-bar">
                    {TABS.map((tab) => (
                        <button
                            key={tab.key}
                            className={`sa-tab-btn${activeTab === tab.key ? " active" : ""}`}
                            onClick={() => handleTabChange(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
                <button className="sa-import-btn" onClick={() => setImportModalOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="17 8 12 3 7 8"/>
                        <line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                    Import Sales Data
                </button>
            </div>

            <div className="sa-tab-content sa-tab-content--roadmap">
                {renderTab()}
            </div>

            {importModalOpen && (
                <ImportSalesModal
                    onClose={() => setImportModalOpen(false)}
                    onImported={() => {}}
                />
            )}
        </div>
    );
};

// ── Roadmap data ─────────────────────────────────────────────────────────────

const OVERVIEW_SECTIONS = [
    {
        title: "Revenue Analysis",
        items: [
            "Market share of net revenues by product type, broken down per location",
            "Line graph — revenue over time segmented by product type",
            "Ratio bar graph — relative share breakdown across product types",
        ],
    },
];

const PRODUCTS_SECTIONS = [
    {
        title: "Sales Metrics",
        items: [
            "Total units sold",
            "Units sold by color",
            "Units sold by strain",
            "Units sold by price category",
        ],
    },
];

const CUSTOMERS_SECTIONS = [
    {
        title: "Customer Performance",
        items: [
            "Top customers by total revenue",
            "Purchase frequency and repeat customer rate",
            "Average order value per customer",
            "New vs. returning customers over time",
        ],
    },
    {
        title: "Customer Insights",
        items: [
            "Customer segmentation by license type",
            "Geographic distribution of customers",
            "Revenue trends by customer over time",
            "Customer lifetime value",
        ],
    },
];

const INVENTORY_SECTIONS = [
    {
        title: "Stock Metrics",
        items: [
            "Total value of inventory",
            "Inventory turnover rate",
            "Order lag time — duration from order placement to product arrival",
            "Shrinkage — amount of inventory lost or damaged",
        ],
    },
    {
        title: "Data Integrity",
        items: [
            "Check integrity of imported data",
            "Combine inventory and sales data to compare and assess discrepancies",
        ],
    },
];

// ── Roadmap component ─────────────────────────────────────────────────────────

const TabRoadmap = ({ sections }) => (
    <div className="sa-roadmap">
        {sections.map((section, i) => (
            <div key={i} className="sa-roadmap-card">
                <p className="sa-roadmap-card-title">{section.title}</p>
                <ul className="sa-roadmap-items">
                    {section.items.map((item, j) => (
                        <li key={j} className="sa-roadmap-item">
                            <span className="sa-roadmap-dot" />
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        ))}
    </div>
);

export default SalesAnalytics;
